/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import StyledSelect from 'app/components/common/StyledSelect.jsx';
import ToggleControl from 'app/components/common/ToggleControl.jsx';
import DatePicker from 'react-widgets/DatePicker';
import * as _ from 'underscore';


class EverqueuePanel extends React.Component {
    constructor(props) {
        super(props);

        let defaultExpiration = new Date();

        this.state = {
            active: false,
            expires: false,
            settings: {
                delay: 0,
                expire: 0
            },
            defaultExpiration: defaultExpiration.getTime() + 7776000000
        };

        this.isPoolSet = this.isPoolSet.bind(this);
        this.isActive = this.isActive.bind(this);
        this.updateControlState = this.updateControlState.bind(this);
        this.updateTimestamp = this.updateTimestamp.bind(this);
        this.setEverqueue = this.setEverqueue.bind(this);
        this.postExpires = this.postExpires.bind(this);

    }

    componentDidMount() {

        this.isPoolSet(this.props);

    }

    componentDidUpdate(prevProps, prevState) {

        if (prevProps.context !== this.props.context || !_.isEqual(this.props.posts, prevProps.posts)) {
            this.isPoolSet(this.props);
        }

    }

    isPoolSet(props) {

        let constants = this.props.app.config.constants,
            settings = this.state.settings,
            expires = this.state.expires,
            post = props.posts[0];

        if ((post.params.postFlag === constants.POST_POOL) || props.context === 'edit-everqueue') {
            if (parseInt(post.params.killTs, 10) !== 0) {
                settings.expire = post.params.killTs;
                expires = true;
            }
            if (post.params.delay) {
                settings.delay = post.params.delay;
            }

            this.setState({
                active: true,
                settings,
                expires
            });
        }

    }

    isActive(e) {

        let active = this.state.active,
            constants = this.props.app.config.constants,
            expires = this.props.expires;

        if (e) {
            active = (e.currentTarget.dataset.togglestate === 'true') ? false : true;

            if (active) {
                this.props.setPostAttribute('postFlag', constants.POST_POOL);
            } else {
                this.props.setPostAttribute('postFlag', constants.POST_QUEUE);
                expires = false;
            }

            this.setState({
                active,
                expires
            });
        }
    }

    postExpires(e) {
        let expires = this.state.expires,
            settings = this.state.settings;

        if (e) {
            expires = (e.currentTarget.dataset.togglestate === 'true') ? false : true;
            if (expires) {
                settings.expire = Math.floor(this.state.defaultExpiration / 1000);
            } else {
                settings.expire = 0;
            }
            this.setEverqueue(settings);
            this.setState({
                expires,
                settings
            });
        }
    }

    updateControlState(e) {
        let settings = this.state.settings;

        if (e) {
            if (e.currentTarget.dataset.field === 'delay') {
                settings.delay = e.currentTarget.value;
                this.setEverqueue(settings);
                this.setState({
                    settings
                });
            }
        }

    }

    updateTimestamp(date, string) {
        let now = new Date(),
            settings = this.state.settings;

        if (date.getTime() <= now.getTime()) {
            return;
        }

        settings.expire = Math.floor(date.getTime() / 1000);
        this.setEverqueue(settings);

        this.setState({
            settings
        });

    }

    setEverqueue(settings) {

        let constants = this.props.app.config.constants,
            dataEvent = {
                currentTarget: {
    	    		dataset: {
    	    			field: ''
    	    		}
    	    	},
    	    	target: {
    	    		value: null
    	    	}
            },
            data = {
                'posts[0].params.postFlag': constants.POST_POOL,
                'posts[0].params.delay': settings.delay,
                'posts[0].params.killTs': settings.expire
            };

        if (this.state.active) {
            for (let key in data) {
                dataEvent.currentTarget.dataset.field = key;
                dataEvent.target.value = data[key];
                this.props.requestChange(dataEvent);
            }
        }

    }

    render () {
        let waitOptions = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
            controlState = (!this.state.active) ? 'disabled' : '',
            pickerState = (this.state.expires) ? false : true,
            date = new Date(),
            adjustedTime = this.state.settings.expire * 1000,
            constants = this.props.app.config.constants,
            activeToggle = null,
            buttonClass = 'btn-primary fixed';

        if (this.state.settings.expire != 0) {
            date.setTime(adjustedTime);
        } else {
            // set the default to now + 90 days
            date.setTime(this.state.defaultExpiration);
        }

        if (this.props.context !== 'edit-everqueue') {
            activeToggle = (
                <ToggleControl
                    activeLabel="Add Post to EverQueue?"
                    inactiveLabel="Add Post to EverQueue?"
                    callback={this.isActive}
                    active={(this.state.active) ? true : false} />
            );
        } else {
            controlState = '';
        }

        // comment out post level delay per charles
        // TODO: if it's added back make sure it picks up the global delay value for the social
        // <div className="panel-section">
        //     Wait <StyledSelect options={waitOptions} controlState={controlState} selectClass="mini" value={this.state.settings.delay} onChange={this.updateControlState} linkedField="delay"/> days after posting an EverQueue Item before it's eligible to be posted again.
        // </div>

        return (
            <div className="panel-content">
                <div className="panel-header">
                    {activeToggle}
                </div>
                <div className="panel-section">
                    <ToggleControl
                        activeLabel="Do not post item after:"
                        inactiveLabel="Do not post item after:"
                        controlState={controlState}
                        callback={this.postExpires}
                        active={(this.state.expires) ? true : false}
                        toggleClass="inline everqueue-expires"
                        labelPlacement="right" />
                    <DatePicker
                        containerClassName="everqueue-expires-picker" 
                        value={date}
                        onChange={this.updateTimestamp}
                        disabled={pickerState}/>
                </div>
                <div className="panel-section twitter-warning">
                    <a href="https://support.dlvrit.com/hc/en-us/articles/360002116333" target="_blank"><em>EverQueue content for Twitter will be retweeted per their policy update.</em></a>
                </div>
            </div>
        );
    }
}

EverqueuePanel.displayName = "EverqueuePanel";

EverqueuePanel.propTypes = {
    panels: PropTypes.object,
    post: PropTypes.object,
    requestChange: PropTypes.func,
    activateAccessory: PropTypes.func
};

EverqueuePanel.defaultProps = {
    panels: {},
    post: {},
    requestChange: null,
    activateAccessory: null
};

export default EverqueuePanel;
